import axios, { AxiosError, AxiosResponse } from "axios";
import { AdsApiResponse, Asset, AssetGroup, GeneralProject } from "../../interface/Server";
import { AssetArea } from '../../enum/'

//  ADS-001
// "Assets List
// Query assets with parameters
//
//     Endpoint:
//         /ads/asset/query
//
// Method:
//     POST
//
// Params:
// {
//     'englishName': 'Big-leaved Fig',
//     'chineseName': '大葉榕',
//     'technicalName': 'Ficus virens',
//     'venue': 'Art Park 藝術公園',
//     'giftAmount': 80000,
//     'pageNumber': 1,
//     'pageSize': 10
// }
//
// Return:
// {
//     'code': '10000',
//     'msg': 'OK',
//     'data':{
//     'pageNo':1,
//         'pageSize':10,
//         'total':1000,
//         'pages':1,
//         'dataList':[{
//         'assetId': 1,
//         'englishName': 'Big-leaved Fig',
//         'chineseName': '大葉榕',
//         'technicalName': 'Ficus virens',
//         'venue': 'Art Park 藝術公園',
//         'location': '1 (Zone A)',
//         'inventoryId': 'AP/1/FV2/001',
//         'online': false,
//         'startDate': '01/01/2019',
//         'endDate': null,
//         'description': null,
//         'source': 'https://wkcda.sharepoint.com/sites/External/det/GGA/DEV/Adopt%20a%20Tree_Materials_20181212_v1.pptx',
//         'purchased': false,
//         'fundraisingUpdates': null,
//         'tcRead': null,
//         'picsRead': null,
//         'giftAcknowledgementEmailSent': null,
//         'accountID': null,
//         'primaryEmail': null,
//         'westKowloonENewsletter': null,
//         'giftId': null,
//         'tributeType': null,
//         'tributeName': null,
//         'acknowledgementNameENG': null,
//         'acknowledgementNameCHI': null,
//         'donorNameInReceipt': null,
//         'project': 'Adopt a Tree',
//         'giftAmount': 80000,
//         'giftAmountCurrency': 'HKD',
//         'tributeDescription': 'AP/1/FV2/001',
//         'image': null
// }]
// }
// }"

export interface AssetsQueryParameters {
    assetStatus?: string | null,
    englishName?: string,
    chineseName?: string,
    technicalName?: string,
    venue?: string,
    giftAmount?: number,
    pageNumber?: number,
    pageSize?: number,
    zone?: string,
    giftAmountMax?: number,
    giftAmountMin?: number,
    type?: string,
    groupBy?: Array<string>
}


export interface GeoBoxQueryParameters {
    giftAmountInterval?: {
        max: number,
        min: number,
      },
    location: {
        bottom_right: {
            lat: number,
            lon: number,
        },
        top_left: {
            lat: number,
            lon: number,
        }
    },
    pageNumber?: number,
    pageSize?: number,
    type?: string,
    zone?: string,
    status?: string
}

export interface AssetGroupType<AssetType> {
    groupName: string,
    dataList: Array<AssetType>,
}


export interface QueryAssetsWithParametersResData<AssetType> {
    pageSize: number,
    total: number,
    pages: number,
    groups: {
        englishName: Array<AssetGroupType<AssetType>>
    },
}

export const queryAssetsWithParameters = (AssetQuery: AssetsQueryParameters) => {
    // return axios.post('/asset/query', AssetQuery).then(
    return axios.post('/asset/queryGroup', AssetQuery).then(
        (res: AxiosResponse) => res.data as AdsApiResponse<QueryAssetsWithParametersResData<Asset>>
    ).catch((err: AxiosError) => {
        console.log('Error at queryAssets: ', err.message);
        return {
            data: {
                dataList: []
            },
            pageSize: 0,
            total: 0,
            pages: 0,
        }
    });
}


// normalise response to object that can be parsed by components
// due to lack of mock data the area and coordinates are randomly generated
export const mapResponseToObject = (dataList: Array<Asset>): { [key: string]: Array<Asset> } => {
    let res = dataList.reduce((assetList: AssetGroup, currentAsset: Asset, index) => {
        // TODO need asset type to better filter / handle asset list
        console.log('currentAsset', currentAsset)
        if(currentAsset.project === 'Pick a Seat' || currentAsset.type === 'Seat') {
            // handle as a Seat project
            const key = `SeatType:${currentAsset.venueEn}`;
            if(!assetList[key]) {
                assetList[key] = [currentAsset];
            } else {
                assetList[key] = [
                    ...assetList[key],
                    currentAsset,
                ];
            }
        } else if(currentAsset.project === 'Sponsor a Bench' || currentAsset.type === 'Bench') {
            const key = `BenchType:${currentAsset.technicalName}`;
            if(!assetList[key]) {
                assetList[key] = [currentAsset];
            } else {
                assetList[key] = [
                    ...assetList[key],
                    currentAsset,
                ];
            }
        } else {
            if(!assetList[currentAsset.technicalName]) {
                assetList[currentAsset.technicalName] = [currentAsset];
            } else {
                assetList[currentAsset.technicalName] = [
                    ...assetList[currentAsset.technicalName],
                    currentAsset,
                ];
            }
        }
        return assetList;
    }, {});
    console.log('mapped res', res);
    return res;
};

export const queryGeoBoxWithParameters = (GeoBoxQuery: GeoBoxQueryParameters) =>
    axios.post('/asset/geoBoxQuery', GeoBoxQuery).then(
        (res: AxiosResponse) => res.data as AdsApiResponse<QueryAssetsWithParametersResData<Asset>>
    ).catch((err: AxiosError) => {
        console.log('Error at queryGeoBox: ', err.message);
        return {
            data: {
                dataList: []
            },
            pageSize: 0,
            total: 0,
            pages: 0,
        }
    });

export const queryGeneralProject = (): Promise<GeneralProject[]> =>
    axios.post('/generalProject/query', {}).then((res: AxiosResponse) => {
        const data = res.data as AdsApiResponse<QueryAssetsWithParametersResData<GeneralProject>>;
        if(data && data.data) {
            return res.data.data.dataList;
        }
        return [];
    }).catch((err: AxiosError) => {
        console.log('Error at queryGeneralProject: ', err.message);
        return [];
    });